/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import { groupActions } from '../../actions/groups';
import { GroupsDetail } from './groups-detail';
import * as dispatchNavigation from '../../actions/navigation';
export const mapStateToProps = function(state) {
    const { group } = state;
    return group;
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        dispatchNavigation: dispatchNavigation.navExport(dispatch),
        addGroupMember: (params)=>{
            runDispatchable(()=>{
                return dispatch(groupActions.addGroupMember(params));
            });
        },
        saveGroup: async (group)=>{
            runDispatchable(()=>{
                return dispatch(groupActions.saveGroup(group));
            });
        },
        deleteGroup: async (groupId)=>{
            runDispatchable(()=>{
                return dispatch(groupActions.deleteGroup(groupId));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GroupsDetail);
